var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bizcomp-bind-new-acct bizcomp ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),_c('nav-tips',{attrs:{"data":_vm.titTips}}),_c('bind-acct',{attrs:{"way":_vm.way}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }